<template>
    <v-card>
        <!-- Summary -->
        <div class="d-flex align-center">
            <v-card-subtitle class="my-auto"
                >Service charge summary</v-card-subtitle
            >
            <v-spacer />
            <date-picker-button
                v-bind:date="servicechargeDetails.date"
                v-on:date-change="$emit('date-change', $event)"
            />
        </div>
        <v-divider />
        <!-- End Summary -->
        <!-- Orders -->
        <v-container fluid v-if="null != servicechargeDetails">
            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-card-text>
                        <v-card
                            class="mb-4"
                            v-for="order in servicechargeDetails.orders"
                            v-bind:key="order.id"
                        >
                            <v-card-title>
                                {{ order.service_charge | currency }}
                                <v-spacer />
                                <small class="text--secondary">{{
                                    new Date(order.completed_at) | date('p')
                                }}</small>
                            </v-card-title>
                            <v-card-subtitle class="py-0"
                                >Order ID: {{ order.id }}</v-card-subtitle
                            >
                            <template v-if="order.destination != null">
                                <v-card-subtitle class="py-0"
                                    >Destination:
                                    {{ order.destination }}</v-card-subtitle
                                >
                            </template>
                            <v-card-subtitle class="py-0">{{
                                order.summary
                            }}</v-card-subtitle>
                            <v-card-subtitle class="pt-1">
                                <v-chip small label
                                    >{{ order.payment_type }}
                                </v-chip>
                            </v-card-subtitle>
                        </v-card>
                        <v-card dark color="primary">
                            <v-card-subtitle class="pb-0"
                                >Service charges total:</v-card-subtitle
                            >
                            <v-card-subtitle class="py-0"
                                >({{
                                    new Date(servicechargeDetails.date)
                                        | date('dd-MMM-yyyy')
                                }})</v-card-subtitle
                            >
                            <v-card-title>{{
                                servicechargeTotal | currency
                            }}</v-card-title>
                        </v-card>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
        <!-- End Orders -->
    </v-card>
</template>

<script>
export default {
    components: {
        'date-picker-button': () => import('@/components/DatePickerButton.vue')
    },
    props: {
        servicechargeDetails: {
            type: Object,
            required: true
        }
    },
    computed: {
        servicechargeTotal() {
            // Total the servicecharge from each order
            return this.servicechargeDetails.orders.reduce(
                (accumulated, order) =>
                    accumulated + Number(order.service_charge),
                0
            );
        }
    }
};
</script>
